import ReferralWidget from './referral-widget.builder';
import referralWidgetBuilderConfig from './referral-widget.builder.config';

export default {
  config: referralWidgetBuilderConfig,
  component: ReferralWidget,
};
